import { SocialSettingsAction } from "./social.actions";
import { SocialSettingsState } from "./social.state";
import { ChannelSettingsSocialTypes } from "./social.types";

const defaultState: SocialSettingsState = {
    socialPageConfigs: {}
}

const socialSettingsReducer = (
    state: SocialSettingsState = defaultState,
    action: SocialSettingsAction
) => {
    switch (action.type) {
        case ChannelSettingsSocialTypes.SET_SOCIAL_PAGE_CONFIGS:
            return {
                ...state,
                socialPageConfigs: action.payload
            };
        case ChannelSettingsSocialTypes.SOCIAL_PAGE_CONFIGS_LOADING:
            return {
              ...state,
              socialPageConfigsIsLoading: action.payload,
            };
        case ChannelSettingsSocialTypes.SET_SELECTED_SOCIAL_PAGE_CONFIG:
            return {
              ...state,
              selectedSocialPageConfig: action.payload,
            };
        case ChannelSettingsSocialTypes.SET_SOCIAL_LOGIN_DETAILS:
            if (!action.payload) {
              return { ...state, socialLoginDetails: undefined };
            }
            return {
              ...state,
              socialLoginDetails: {
                ...state.socialLoginDetails,
                ...action.payload,
              },
            };
        case ChannelSettingsSocialTypes.SOCIAL_LOGIN_DETAILS_LOADING:
                return {
                  ...state,
                  socialLoginDetailsIsLoading: action.payload,
            };
        default:
            return state;
    }
};

export default socialSettingsReducer;